/**
 * Unique identifier for the Inspire feature group.
 */
export const INSPIRE_FEATURE_GROUP_ID = "INSPIRE_FEATURE_GROUP";
